import { store, getContext, getElement, getConfig } from '@wordpress/interactivity';

const { state } = store( 'gt/menu', {
    actions: {
        setMenus: () => {
            if(!state.menus) return;
            const context = getContext();
            Object.keys(context.menus).forEach((key) => { 
                state.menus[key] = context.menus[key];
            });
            
        },
        setMenusMobile: () => {
            if(!state.menus) return;
            // Utilisation de la fonction de clonage
            const menusMobile = deepClone(state.menus);
            const submenusMobile = deepClone(state.submenus);
        
            Object.keys(menusMobile).forEach((key) => {
                menusMobile[key].anchor = 'gt-item-menu-' + menusMobile[key].id;
                menusMobile[key].id += '-mobile';
                menusMobile[key].controls += '-mobile';
            });
        
            Object.keys(submenusMobile).forEach((key) => {
                submenusMobile[key].id += '-mobile';
                submenusMobile[key].controls += '-mobile';
                
                
            });
            
            // Assignation des copies modifiées à l'état
            state.menusMobile = menusMobile;
            state.submenusMobile = submenusMobile;

        },
    }
});


function deepClone(obj) {
    if (obj === null || typeof obj !== 'object') {
        return obj; // retourne la valeur primitive
    }

    if (Array.isArray(obj)) {
        return obj.map(item => deepClone(item)); // clone les tableaux
    }

    const clonedObj = {};
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            clonedObj[key] = deepClone(obj[key]); // clone récursivement
        }
    }
    return clonedObj;
}
